// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@gcg/XDL/types";

import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        headerTypographyProps: {
            size: "16px",
            lineHeight: "22px",
            color: "#2c2c2c",
            transform: "capitalize",
            weight: "normal",
            css: css`
                letter-spacing: 0.46px;
            `,
        },
        cssOverrides: {
            header: css`
                background: ${getColor("common.ui2")};
                width: auto;
                text-align: left;
                text-transform: capitalize;
                border: 0;
                border-top: 3px solid ${getColor("common.ui7")};
                border-bottom: 1px solid ${getColor("common.ui7")};
                height: 48px;
                position: relative;

                button {
                    justify-content: flex-start;
                }
            `,
            body: css`
                a span {
                    font-size: 14px;
                    line-height: 18px;
                }

                tr {
                    &:nth-child(even) {
                        background-color: ${getColor("primary.contrast")};
                    }
                }

                tr:hover,
                tr:focus {
                    background: #f1f1f1 !important;
                    cursor: pointer;
                }
            `,
            cell: css`
                padding: 5px 12px;
                border: 0;
                border-bottom: 1px solid ${getColor("common.ui7")};
                height: 70px;
            `,
        },
        cellTypographyProps: {
            size: 16,
            color: "#2c2c2c",
            lineHeight: "18px",
        },
    },
} as xBaseTheme["dataTable"];
